// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { accountCenterFieldControlGuard, webauthnRelatedOriginsGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    enabled: z.boolean().optional(),
    fields: accountCenterFieldControlGuard.optional(),
    webauthnRelatedOrigins: webauthnRelatedOriginsGuard.optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    enabled: z.boolean(),
    fields: accountCenterFieldControlGuard,
    webauthnRelatedOrigins: webauthnRelatedOriginsGuard,
});
export const AccountCenters = Object.freeze({
    table: 'account_centers',
    tableSingular: 'account_center',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        enabled: 'enabled',
        fields: 'fields',
        webauthnRelatedOrigins: 'webauthn_related_origins',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'enabled',
        'fields',
        'webauthnRelatedOrigins',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
